<div #multipleBarChart style="width: 100%; height: calc(100% - 27px); position: relative;" class="chartBarThree"></div>

<div class="list-button">
  <ul class="graph-point events-graph">
    @for (item of subgroups(); track item) {
    <li>
        <div class="legend-color" [style.backgroundColor]="item?.color || 'gray'"></div>{{item?.legend || ''}}
    </li>
    }
  </ul>
  @if (exportBtn()) {
  <div class="export-listing">
    <div class="common-drop-down dropdown">
      <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdown-menubutton" data-bs-toggle="dropdown"
        aria-expanded="false">
        Export <i><img src="./assets/images-fuel/downloadIcon.svg" alt="export-icon" /></i>
      </button>
      <ul class="dropdown-menu" aria-labelledby="dropdown-menubutton">
        <li><a class="dropdown-item">Export as pdf</a></li>
        <li><a class="dropdown-item">Export as csv</a></li>
        <li><a class="dropdown-item">Send via email</a></li>
      </ul>
    </div>
  </div>
  }
</div>